import { formatDate, MappingStatus, MappingStyles } from "../../utils/utils";

import React, { useState } from "react";

export default function ProcessingTable({
  selectedAll,
  selectedApplicants,
  handleSelectAll,
  filteredApplicants,
  handleSelectApplicant, // Ensure this is the one used
  handleViewApplication,
}) {
  const applicantsToRender = Array.isArray(filteredApplicants)
    ? filteredApplicants
    : [];

  return (
    <div className="  bg-[#131313] rounded-lg border border-[#333333] w-full  overflow-x-auto scrollbar-hide">
      <table className="min-w-full">
        <thead className="border-y border-[#333333]">
          <tr>
            <th className="p-4 text-center border-2 border-[#333333]">
              <input
                type="checkbox"
                className="appearance-none h-5 w-5 border border-white rounded-sm bg-transparent checked:bg-yellow-400 checked:border-yellow-400 checked:appearance-none relative cursor-pointer
             before:content-['✔'] before:absolute before:text-white before:inset-0 before:flex before:items-center before:justify-center before:text-sm before:font-bold before:opacity-0 checked:before:opacity-100"
                checked={selectedAll}
                onChange={handleSelectAll}
              />
            </th>
            <th className="p-4 text-center border-2 border-[#333333]">DATE</th>
            <th className="p-4 text-center border-2 border-[#333333]">
              APPLICANT NAME
            </th>
            <th className="p-4 text-center border-2 border-[#333333]">
              LOAN AMOUNT
            </th>
            <th className="p-4 text-center border-2 border-[#333333]">
              CREDIT LIMIT
            </th>
            <th className="p-4 text-center border-2 border-[#333333]">
              PROCESSING TYPE
            </th>
            <th className="p-4 text-center border-2 border-[#333333]">
              BANK NAME
            </th>
            <th className="p-4 text-center border-2 border-[#333333]">
              PROCESSING TIME
            </th>
            <th className="p-4 text-center border-2 border-[#333333]">
              ACTIONS
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-800">
          {applicantsToRender.length === 0 ? (
            <tr>
              <td colSpan="8" className="p-6 text-center text-gray-400">
                No rows found
              </td>
            </tr>
          ) : (
            applicantsToRender.length > 0 &&
            applicantsToRender.map((applicant, index) => (
              <tr key={index} className=" text-white border-t border-[#333333]">
                <td className="p-4 text-center border-2 border-[#333333]">
                  <input
                    type="checkbox"
                    className="appearance-none h-5 w-5 border-2 border-white rounded-sm bg-transparent checked:bg-yellow-400 checked:border-yellow-400 checked:appearance-none relative cursor-pointer
                      before:content-['✓'] before:absolute before:text-white before:inset-0 before:flex before:items-center before:justify-center before:text-sm before:font-bold before:opacity-0 checked:before:opacity-100"
                    checked={selectedApplicants.includes(applicant._id)}
                    onChange={() => handleSelectApplicant(applicant._id)} // Use handleSelectApplicant
                  />
                </td>
                <td className="p-4 text-center border-2 border-[#333333]">
                  {formatDate(applicant.createdAt)}
                </td>
                <td className="p-4 text-center border-2 border-[#333333]">
                  {applicant?.user?.name}
                </td>
                <td className="p-4 text-center border-2 border-[#333333]">
                  <div>
                    <div>{applicant.principle}</div>
                    <div className="text-sm text-gray-400">
                      {applicant.loanType}
                    </div>
                  </div>
                </td>
                <td className="p-4 text-center border-2 border-[#333333]">
                  <span
                    className={`px-3 py-1 rounded-full text-sm ${MappingStyles(
                      applicant.status
                    )}
                                                               `}
                  >
                    {MappingStatus(applicant.status)}
                  </span>
                </td>
                <td className="p-4 text-center border-2 border-[#333333]">
                  {applicant.processingMethod}
                </td>
                <td className="p-4 text-center border-2 border-[#333333]">
                  <div className="flex items-center gap-2">
                    <span>{applicant.processingBank}</span>
                  </div>
                </td>
                <td>1 day</td>
                <td className="p-4 text-center border-2 border-[#333333]">
                  <button
                    className="text-[#FFCA20] hover:text-[#FFCA20]"
                    onClick={() => handleViewApplication(applicant._id)}
                  >
                    View
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
